import { schema } from "normalizr";

export const expertPreviewSchema = new schema.Entity("expertPreviews");